import React, { useState, useEffect } from 'react'
import { supabase, SUPABASE_URL } from './supabaseClient'
import { useIsMobile } from './useIsMobile'
import { CopyButton } from './CopyButton'
import { C, FONT } from './theme'
import { carregarPortes, PORTES_COBRADOS_FALLBACK } from './portes'
import { guardarCarrinho } from './carrinhoStorage'
import {
  Package, TrendingUp, AlertTriangle, CheckCircle,
  Plus, Minus, Clock, Truck, ChevronRight, Database, Save,
  RefreshCw, Search, User, Shield, Settings, X, Trash2, Send,
  ShoppingCart, Check,
} from 'lucide-react'
import {

  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, ReferenceLine,
} from 'recharts'
import { SLOTS_TRANSITO } from './constants'

const fmt = (n) => Number(n || 0).toFixed(2)
const fmtInt = (n) => Math.round(Number(n || 0))
const fmtDate = (d) => d ? new Date(d).toLocaleDateString('pt-PT') : '—'
const addDays = (date, days) => { const d = new Date(date); d.setDate(d.getDate() + days); return d }

function Field({ label, children }) {
  return (
    <div>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: C.textMuted, marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</label>
      {children}
    </div>
  )
}

function InputRow({ label, campo, value, onUpd, step = 1, min = 0, readOnly = false }) {
  return (
    <Field label={label}>
      <div style={{ display: 'flex', gap: '1px' }}>
        <button onClick={() => onUpd(campo, Math.max(min, value - step))} disabled={readOnly} style={{ width: '32px', height: '32px', border: `1px solid ${C.border}`, borderRight: 'none', borderRadius: '6px 0 0 6px', backgroundColor: C.bg, cursor: readOnly ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.textMuted, opacity: readOnly ? 0.5 : 1 }}>
          <Minus size={13} />
        </button>
        <input type="number" value={value} onChange={(e) => onUpd(campo, e.target.value)} min={min} readOnly={readOnly}
          style={{ flex: 1, height: '32px', padding: '0 8px', border: `1px solid ${C.border}`, backgroundColor: readOnly ? C.bg : C.surface, color: readOnly ? C.textMuted : C.text, fontSize: '14px', textAlign: 'center', outline: 'none' }} />
        <button onClick={() => onUpd(campo, value + step)} disabled={readOnly} style={{ width: '32px', height: '32px', border: `1px solid ${C.border}`, borderLeft: 'none', borderRadius: '0 6px 6px 0', backgroundColor: C.bg, cursor: readOnly ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.textMuted, opacity: readOnly ? 0.5 : 1 }}>
          <Plus size={13} />
        </button>
      </div>
    </Field>
  )
}

function KpiCard({ label, value, icon: Icon, color, subtitle }) {
  return (
    <div style={{ backgroundColor: C.surface, borderRadius: '10px', padding: '16px 20px', border: `1px solid ${C.border}`, boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
        <span style={{ fontSize: '11px', color: C.textMuted, fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px' }}>{label}</span>
        <Icon size={16} color={color} />
      </div>
      <div style={{ fontSize: '22px', fontWeight: '700', color }}>{value}</div>
      {subtitle && (
        <div style={{ fontSize: '10px', color: C.textMuted, marginTop: '4px', fontWeight: '500' }}>{subtitle}</div>
      )}
    </div>
  )
}

// ── O COMPARADOR DE CADA PAIS ───────────────────────────────────────────────
//
// Ter a Buy Box num marketplace nao e ser o mais barato do PAIS. Se a Notino
// estiver trinta euros abaixo, o comprador ve as duas e vai a Notino — a Buy Box
// nao serve de nada e o stock fica parado sem se perceber porque.
//
// OS LINKS SAO COLADOS, NAO DEDUZIDOS. Tentou-se construi-los por regra e falhou
// em quatro dos nove mercados: o Idealo usa /precios/ em Espanha e /prix/ em
// Franca, mas o que se adivinhou para a Alemanha, a Austria e a Italia estava
// errado. Deduzir o URL de um site que nao controlamos e adivinhar.
//
// O PAIS SAI DO DOMINIO. Um link de heureka.cz arquiva-se na Chequia, um de
// idealo.fr em Franca. Serve qualquer comparador — Idealo, Heureka, Ceneo,
// Trovaprezzi, ou o que aparecer — sem tocar no codigo para acrescentar sites.
const TLD_PARA_PAIS = {
  de: 'de', at: 'at', fr: 'fr', es: 'es', it: 'it',
  nl: 'nl', cz: 'cz', sk: 'sk', pl: 'pl', pt: 'pt',
}

// De "https://www.idealo.fr/prix/..." tira "fr" e "Idealo".
const lerLinkComparador = (bruto) => {
  const texto = String(bruto || '').trim()
  if (!texto) return null
  let u
  try { u = new URL(texto.startsWith('http') ? texto : 'https://' + texto) } catch { return null }
  const partes = u.hostname.toLowerCase().replace(/^www\./, '').split('.')
  const tld = partes[partes.length - 1]
  const sf = TLD_PARA_PAIS[tld]
  if (!sf) return null
  const nome = partes[partes.length - 2] || u.hostname
  return { sf, url: u.href, nome: nome.charAt(0).toUpperCase() + nome.slice(1) }
}

export default function Dashboard({ isReadOnly, perfil, setActivePage, viewAsEmail }) {
  const isMobile = useIsMobile()
  const [produtos, setProdutos] = useState([])
  const [clientes, setClientes] = useState([])
  const [selected, setSelected] = useState(null)
  const [form, setForm] = useState({})
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [successMsg, setSuccessMsg] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const [editMode, setEditMode] = useState(false)
  const [modalPos, setModalPos] = useState({ x: 0, y: 0 })
  const dragRef = React.useRef(null)

  const startDrag = (e) => {
    if (e.button !== 0) return
    const startX = e.clientX - modalPos.x
    const startY = e.clientY - modalPos.y
    const onMove = (ev) => setModalPos({ x: ev.clientX - startX, y: ev.clientY - startY })
    const onUp = () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp) }
    window.addEventListener('mousemove', onMove)
    window.addEventListener('mouseup', onUp)
  }
  const [showNovoProduto, setShowNovoProduto] = useState(false)
  const [searchProduto, setSearchProduto] = useState('')
  const [novoProduto, setNovoProduto] = useState({ Nome: '', EAN: '', Vendas_Mensais: 0, Stock_Atual: 0, Lead_Time: 7, Objetivo_Cobertura: 30, Email_Cliente: '' })
  const [criando, setCriando] = useState(false)
  const [enviandoEmail, setEnviandoEmail] = useState(false)
  const [emailMsg, setEmailMsg] = useState({ tipo: '', texto: '' })
  const [sincronizandoLognow, setSincronizandoLognow] = useState(false)
  const [historico, setHistorico] = useState([])
  // ── BUY BOX POR PAIS ──────────────────────────────────────────────────────
  //
  // O mesmo frasco esteve a 108 EUR na Alemanha e a 199,69 em Franca no mesmo
  // dia — 3 EUR de lucro contra 64. A decisao de onde pôr uma unidade vale mais
  // do que a de quantas comprar, e era tomada a olho.
  //
  // Mostra-se por artigo e nao num ecra proprio: a pergunta "onde ponho isto"
  // faz-se a olhar para o artigo, e um ecra separado obrigava a procurá-lo
  // outra vez.
  const [buybox, setBuybox] = useState([])
  const [buyboxErro, setBuyboxErro] = useState('')
  // Os links de comparador deste artigo, por pais.
  const [linksPais, setLinksPais] = useState({})
  const [guardandoRef, setGuardandoRef] = useState(false)
  // Repor stock (cliente / admin em viewAs): perfil efectivo + popover + toast
  const [perfilCliente, setPerfilCliente] = useState(null)
  const [portesBase, setPortesBase] = useState(PORTES_COBRADOS_FALLBACK)
  const [verDivergencias, setVerDivergencias] = useState(false)
  const [popoverAdd, setPopoverAdd] = useState(null) // { produto, qtdSugerida }
  const [qtdAdd, setQtdAdd] = useState(0)
  const [toastCarrinho, setToastCarrinho] = useState(null) // { nProdutos, valor }
  const [carrinhoQtd, setCarrinhoQtd] = useState(0)

  useEffect(() => {
    loadProdutos()
    if (!isReadOnly) loadClientes()
  }, [isReadOnly, perfil?.email])

  // Portes da config — tem de bater certo com o Catálogo, senão o mesmo produto
  // fica com preços diferentes conforme a página onde é posto no carrinho
  useEffect(() => {
    let cancelado = false
    ;(async () => {
      const p = await carregarPortes(supabase)
      if (!cancelado) setPortesBase(p.cobrados)
    })()
    return () => { cancelado = true }
  }, [])

  // Carregar perfil do cliente quando admin entra como cliente (para preços/portes correctos)
  useEffect(() => {
    if (!viewAsEmail) { setPerfilCliente(null); return }
    ;(async () => {
      const { data } = await supabase.from('perfis').select('*').eq('email', viewAsEmail).maybeSingle()
      setPerfilCliente(data || null)
    })()
  }, [viewAsEmail])

  // Sincronizar contador de carrinho com localStorage
  useEffect(() => {
    const ler = () => {
      try {
        const raw = localStorage.getItem('carrinho')
        if (!raw) { setCarrinhoQtd(0); return }
        const arr = JSON.parse(raw)
        setCarrinhoQtd(Array.isArray(arr) ? arr.reduce((s, it) => s + Number(it.quantidade || 0), 0) : 0)
      } catch { setCarrinhoQtd(0) }
    }
    ler()
    const onStorage = (e) => { if (e.key === 'carrinho') ler() }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  // Perfil efectivo: viewAsEmail → perfilCliente, senão perfil do utilizador autenticado
  const perfilEfectivo = perfilCliente || perfil
  // Portes: mesma base que o Catálogo usa (config_sistema.portes_por_unidade).
  // Estava aqui 0.75 fixo, o que agravava o preço em +0.25/un aos clientes com
  // portes 1.00 na ficha — o mesmo produto ficava mais caro por esta página.
  const portesDoCliente = perfilEfectivo?.portes_por_unidade != null ? Number(perfilEfectivo.portes_por_unidade) : PORTES_COBRADOS_FALLBACK
  const portesDiff = Math.max(0, portesDoCliente - portesBase)
  const isParticular = perfilEfectivo?.tipo_cliente === 'particular'
  const IVA = 0.23

  // Adicionar produto ao carrinho (mesma estrutura do Catalogo · localStorage 'carrinho')
  const adicionarAoCarrinho = (produto, qtd) => {
    const qtdMin = perfilEfectivo?.qtd_minima_compra || produto.qtd_minima_compra || 10
    const qtdFinal = Math.max(qtdMin, Number(qtd) || qtdMin)
    const precoBase = isParticular
      ? Number(produto.preco_particular || 0)
      : (Number(produto.preco || 0) + portesDiff)
    const precoComIva = precoBase * (1 + IVA)
    try {
      const raw = localStorage.getItem('carrinho')
      const prev = raw ? JSON.parse(raw) : []
      const arr = Array.isArray(prev) ? prev : []
      const existente = arr.find(it => it.Nome === produto.Nome)
      let novo
      if (existente) {
        novo = arr.map(it => it.Nome === produto.Nome ? {
          ...it,
          quantidade: it.quantidade + qtdFinal,
          preco_unitario: precoBase,
          total_sem_iva: precoBase * (it.quantidade + qtdFinal),
          total_com_iva: precoComIva * (it.quantidade + qtdFinal),
          preco_com_iva: precoComIva,
        } : it)
      } else {
        novo = [...arr, {
          ...produto,
          quantidade: qtdFinal,
          preco_unitario: precoBase,
          total_sem_iva: precoBase * qtdFinal,
          total_com_iva: precoComIva * qtdFinal,
          preco_com_iva: precoComIva,
        }]
      }
      guardarCarrinho(novo)
      const totalQtd = novo.reduce((s, it) => s + Number(it.quantidade || 0), 0)
      const totalValor = novo.reduce((s, it) => s + Number(it.total_com_iva || 0), 0)
      setCarrinhoQtd(totalQtd)
      setToastCarrinho({ nProdutos: novo.length, valor: totalValor, qtdAdicionada: qtdFinal, nomeProduto: produto.Nome })
      setTimeout(() => setToastCarrinho(null), 6000)
    } catch (e) {
      alert('Erro ao adicionar ao carrinho: ' + e.message)
    }
  }

  const loadClientes = async () => {
    const { data } = await supabase.from('perfis').select('id, nome, email, role').order('nome')
    setClientes(data || [])
  }

  const loadProdutos = async () => {
    setLoading(true)
    setErrorMsg('')
    try {
      // Colunas admin-only ("notas_admin", "desconto_supplier_pct", "Transito*_Factura")
      // são omitidas quando o utilizador está em readonly (cliente logado).
      const colsCliente = 'id, Nome, EAN, categoria, preco, preco_particular, preco_mercado, foto_url, Stock_Atual, visivel_catalogo, Email_Cliente, qtd_minima_compra, Vendas_Mensais, vendas_mensais_manual, Lead_Time, Objetivo_Cobertura, Transito1_Qtd, Transito1_Data, Transito2_Qtd, Transito2_Data, Transito3_Qtd, Transito3_Data, Transito4_Qtd, Transito4_Data, Transito5_Qtd, Transito5_Data, Data_Contagem, stock_lognow, preco_manual'
      let query = supabase.from('Produtos').select(isReadOnly ? colsCliente : '*').order('Nome')
      const emailToUse = viewAsEmail || (isReadOnly && perfil?.email ? perfil.email : null)
      if (emailToUse) query = query.eq('Email_Cliente', emailToUse)
      else if (!isReadOnly) query = query.not('Email_Cliente', 'is', null)
      const { data, error } = await query
      if (error) throw error
      setProdutos(data || [])
      if (data && data.length > 0) {
        const nomeAtual = selected?.Nome
        const mesmo = nomeAtual ? data.find(p => p.Nome === nomeAtual) : null
        // Se o utilizador ja tinha um produto seleccionado, manter (ex: depois de gravar).
        // Em desktop, auto-seleccionar o primeiro produto (a sidebar mostra ambos).
        // Em mobile, NAO auto-seleccionar — mostrar a lista para o utilizador escolher
        // (sidebar e o detalhe sao views mutuamente exclusivas em mobile).
        if (mesmo) selectProduto(mesmo)
        else if (!isMobile) selectProduto(data[0])
      }
      else { setSelected(null); setForm({}) }
    } catch (err) {
      setErrorMsg('Erro ao carregar dados: ' + err.message)
    } finally {
      setLoading(false)
    }
  }

  // Le a tabela das LIBERTACOES e nao a das desassociacoes manuais.
  //
  // Este painel mostrava so as manuais, porque era a unica tabela que a antiga
  // consulta conhecia — um artigo solto pelo automatismo ao fim de 15 dias sem
  // stock aparecia aqui como se nunca tivesse tido dono. Agora as duas formas
  // vem juntas, com a origem a distingui-las.
  const loadHistorico = async (nomeProduto) => {
    const { data } = await supabase
      .from('historico_libertacao_produtos')
      .select('id, libertado_em, origem, ex_dono_email, ex_dono_nome, libertado_por')
      .eq('produto_nome', nomeProduto)
      .order('libertado_em', { ascending: false })
    setHistorico(data || [])
  }

  const selectProduto = (p) => {
    setSelected(p)
    if (!isReadOnly) loadHistorico(p.Nome)
    setForm({
      Nome: p.Nome || '', EAN: p.EAN || '',
      Vendas_Mensais: fmt(p.Vendas_Mensais),
      Stock_Atual: fmtInt(p.Stock_Atual),
      Lead_Time: fmtInt(p.Lead_Time),
      Objetivo_Cobertura: fmtInt(p.Objetivo_Cobertura) || 30,
      ...Object.fromEntries(SLOTS_TRANSITO.flatMap(n => [
        [`Transito${n}_Qtd`, fmtInt(p[`Transito${n}_Qtd`])],
        [`Transito${n}_Data`, p[`Transito${n}_Data`] || ''],
      ])),
      Data_Contagem: p.Data_Contagem || new Date().toISOString().split('T')[0],
      Email_Cliente: p.Email_Cliente || '',
    })
    setSuccessMsg('')
    setErrorMsg('')
    setEditMode(false)
  }

  const upd = (campo, valor) => {
    // O cliente nao edita NADA do produto. O stock e os transitos sao geridos
    // pela LOGNOW e sincronizados; se ele pudesse escrever 20 onde ha 10,
    // corrompia a base de todas as decisoes (reposicao, previsao, pedidos ao
    // fornecedor). A politica de UPDATE na BD tambem lhe foi retirada — isto
    // aqui e so para o ecra nao aceitar o que nunca chegaria a gravar.
    if (isReadOnly) return
    const numFields = ['Vendas_Mensais', 'Stock_Atual', 'Lead_Time', 'Objetivo_Cobertura', ...SLOTS_TRANSITO.map(n => `Transito${n}_Qtd`)]
    setForm(prev => ({ ...prev, [campo]: numFields.includes(campo) ? Math.max(0, Number(valor) || 0) : valor }))
  }

  const triggerLognowSync = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) return
      await fetch(`${SUPABASE_URL}/functions/v1/sync-lognow-stock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({}),
      })
    } catch (err) {
      console.warn('Auto-sync LOGNOW falhou:', err?.message || err)
    }
  }

  // -- CONFIRMAR A CHEGADA DE UM TRANSITO, A MAO --------------------------
  //
  // O sync-lognow-stock so fecha um transito quando a subida de stock do dia
  // iguala a quantidade em T1. E conta por diferenca de saldo, nao por entrada:
  // a 01/09/2026 chegaram 10 unidades do YSL Libre e vendeu-se uma no mesmo
  // dia, o sistema viu nove, e ficou uma unidade em transito que ja estava no
  // armazem. Com artigos que vendem e lotes grandes, isto repete-se.
  //
  // Nao havia forma de dizer "isto chegou, fecha". A saida obvia — por o
  // Transito1_Qtd a zero — e uma armadilha: o sync tem a guarda `t1q > 0` logo
  // a entrada, portanto um T1 a zero congela tudo o que esta atras dele. No
  // YSL isso deixaria as 30 unidades da factura 105 presas no T2 para sempre.
  //
  // Este botao faz a MESMA rotacao que a edge function faz, e sobre os quatro
  // campos de cada slot. So mexer nos que estao no formulario (Qtd e Data)
  // deixava a Factura e a Data_Original do slot anterior coladas a quantidade
  // nova — o transito passava a dizer que 30 unidades da 105 sao da 100.
  const [confirmandoChegada, setConfirmandoChegada] = useState(false)
  const confirmarChegadaT1 = async () => {
    if (!selected || isReadOnly) return
    const t1 = fmtInt(form.Transito1_Qtd)
    if (!(t1 > 0)) { setErrorMsg('Não há nada no trânsito 1 para confirmar.'); return }
    if (!window.confirm(
      `Confirmar que as ${t1} unidades do trânsito 1 já entraram em armazém?

` +
      `O trânsito 1 fecha e os seguintes sobem um lugar.

` +
      `Usa isto quando o armazém confirmou a entrada mas o sistema não a fechou ` +
      `— tipicamente porque houve vendas do mesmo artigo no dia em que chegou.`
    )) return
    setConfirmandoChegada(true); setErrorMsg('')
    try {
      // Le-se a linha inteira: a Factura e a Data_Original nao estao no
      // formulario e tem de rodar com o resto.
      const campos = SLOTS_TRANSITO.flatMap(n => [
        `Transito${n}_Qtd`, `Transito${n}_Data`, `Transito${n}_Data_Original`, `Transito${n}_Factura`,
      ]).map(c => `"${c}"`).join(', ')
      const { data: actual, error: errLer } = await supabase
        .from('Produtos').select(campos).eq('id', selected.id).single()
      if (errLer) throw new Error('Ler trânsitos: ' + errLer.message)

      const N = SLOTS_TRANSITO.length
      const payload = { transito_rotacionado_em: new Date().toISOString().slice(0, 10) }
      for (let i = 0; i < N - 1; i++) {
        const de = SLOTS_TRANSITO[i + 1], para = SLOTS_TRANSITO[i]
        payload[`Transito${para}_Qtd`] = Number(actual[`Transito${de}_Qtd`] || 0)
        payload[`Transito${para}_Data`] = actual[`Transito${de}_Data`] ?? null
        payload[`Transito${para}_Data_Original`] = actual[`Transito${de}_Data_Original`] ?? null
        payload[`Transito${para}_Factura`] = actual[`Transito${de}_Factura`] ?? null
      }
      const ultimo = SLOTS_TRANSITO[N - 1]
      payload[`Transito${ultimo}_Qtd`] = 0
      payload[`Transito${ultimo}_Data`] = null
      payload[`Transito${ultimo}_Data_Original`] = null
      payload[`Transito${ultimo}_Factura`] = null

      const { error } = await supabase.from('Produtos').update(payload).eq('id', selected.id)
      if (error) throw new Error(error.message)
      await loadProdutos()
      setSelected(p => (p ? { ...p, ...payload } : p))
      setForm(f => ({
        ...f,
        ...Object.fromEntries(SLOTS_TRANSITO.flatMap(n => [
          [`Transito${n}_Qtd`, payload[`Transito${n}_Qtd`] ?? 0],
          [`Transito${n}_Data`, payload[`Transito${n}_Data`] || ''],
        ])),
      }))
    } catch (e) {
      setErrorMsg('Não foi possível confirmar a chegada: ' + (e.message || String(e)))
    } finally {
      setConfirmandoChegada(false)
    }
  }

  const guardar = async () => {
    if (!selected) return
    setSaving(true)
    setErrorMsg('')
    try {
      const emailAnterior = selected.Email_Cliente || ''
      const emailNovo     = isReadOnly ? emailAnterior : (form.Email_Cliente || '')
      const desassociou   = !isReadOnly && emailAnterior !== '' && emailNovo === ''
      const associou      = !isReadOnly && emailNovo !== ''

      if (desassociou) {
        const { data: perf } = await supabase.from('perfis').select('nome').eq('email', emailAnterior).single()
        await supabase.from('produto_historico_clientes').insert({
          produto_nome:    selected.Nome,
          cliente_email:   emailAnterior,
          cliente_nome:    perf?.nome || emailAnterior,
          desassociado_em: new Date().toISOString(),
        })
      }

      const updatePayload = {
        Vendas_Mensais:    form.Vendas_Mensais,
        Stock_Atual:       form.Stock_Atual,
        Lead_Time:         form.Lead_Time,
        Objetivo_Cobertura: form.Objetivo_Cobertura,
        ...Object.fromEntries(SLOTS_TRANSITO.flatMap(n => [
          [`Transito${n}_Qtd`, form[`Transito${n}_Qtd`] || 0],
          [`Transito${n}_Data`, form[`Transito${n}_Data`] || null],
        ])),
        Data_Contagem:     form.Data_Contagem || null,
        updated_at:        new Date().toISOString(),
      }
      if (!isReadOnly) {
        updatePayload.Email_Cliente    = emailNovo || null
        updatePayload.visivel_catalogo = desassociou ? true : (associou ? false : selected.visivel_catalogo)
      }

      const { error } = await supabase.from('Produtos').update(updatePayload).eq('Nome', selected.Nome)
      if (error) throw error

      const eanAtual = selected.EAN || form.EAN
      const associacaoMudou = !isReadOnly && emailAnterior !== emailNovo
      if (!isReadOnly && eanAtual && emailNovo && associacaoMudou) {
        setSuccessMsg('Guardado. A sincronizar com LOGNOW…')
        await triggerLognowSync()
      }

      setSuccessMsg('Guardado com sucesso.')
      setTimeout(() => setSuccessMsg(''), 4000)
      await loadProdutos()
    } catch (err) {
      setErrorMsg('Erro ao guardar: ' + err.message)
    } finally {
      setSaving(false)
    }
  }

  const eliminarProduto = async () => {
    if (!selected) return
    if (!window.confirm(`Tem a certeza que quer eliminar "${selected.Nome}"? Esta ação é irreversível.`)) return
    try {
      const { error } = await supabase.from('Produtos').delete().eq('Nome', selected.Nome)
      if (error) throw error
      setEditMode(false)
      setSelected(null)
      setForm({})
      await loadProdutos()
    } catch (err) {
      setErrorMsg('Erro ao eliminar produto: ' + err.message)
    }
  }

  const criarProduto = async (e) => {
    e.preventDefault()
    if (!novoProduto.Nome.trim()) return
    setCriando(true)
    try {
      const { error } = await supabase.from('Produtos').insert([{
        Nome: novoProduto.Nome.trim(),
        EAN: novoProduto.EAN || null,
        Vendas_Mensais: novoProduto.Vendas_Mensais,
        Stock_Atual: novoProduto.Stock_Atual,
        Lead_Time: novoProduto.Lead_Time,
        Objetivo_Cobertura: novoProduto.Objetivo_Cobertura,
        Email_Cliente: novoProduto.Email_Cliente || null,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }])
      if (error) throw error

      if (novoProduto.EAN && novoProduto.Email_Cliente) {
        await triggerLognowSync()
      }

      setShowNovoProduto(false)
      setNovoProduto({ Nome: '', EAN: '', Vendas_Mensais: 0, Stock_Atual: 0, Lead_Time: 7, Objetivo_Cobertura: 30, Email_Cliente: '' })
      await loadProdutos()
    } catch (err) {
      setErrorMsg('Erro ao criar produto: ' + err.message)
    } finally {
      setCriando(false)
    }
  }

  const calc = () => {
    if (!selected) return null
    const vm  = fmt(form.Vendas_Mensais)
    const lt  = fmtInt(form.Lead_Time) || 1
    const sa  = fmtInt(form.Stock_Atual)
    const oc  = fmtInt(form.Objetivo_Cobertura) || 30
    const hoje = new Date(); hoje.setHours(0, 0, 0, 0)

    // Os slots lidos do formulario. Cinco desde 29/08/2026 (ver
    // supabase/sql/transitos_t4_t5.sql); eram tres e estavam escritos a mao,
    // um bloco por slot.
    const trans = SLOTS_TRANSITO.map(n => {
      const qtd = fmtInt(form[`Transito${n}_Qtd`])
      const data = form[`Transito${n}_Data`]
      const dias = (qtd > 0 && data)
        ? Math.floor((new Date(new Date(data).setHours(0, 0, 0, 0)) - hoje) / 86400000)
        : null
      return { n, qtd, data, dias }
    })

    const vd  = vm / 30
    const diasSoStock = vd > 0 ? Math.floor(sa / vd) : 9999
    const dataEsgotar = addDays(hoje, diasSoStock)

    const stockRestanteNoDia = (dia) => Math.max(0, sa - vd * Math.max(0, dia))

    // ── Projeccao encadeada ──────────────────────────────────────────────────
    // Cada chegada parte do que sobrou da anterior. Antes eram tres blocos
    // escritos a mao, e o terceiro tinha de perguntar pelo segundo e, se nao
    // houvesse, pelo primeiro. Com cinco slots isso eram cadeias de cinco
    // ramos, escritas quatro vezes — a forma mais certa de ficarem diferentes
    // umas das outras sem ninguem reparar.
    //
    // Ordena-se por data de chegada e nao por numero de slot. E o que ja se
    // queria: os blocos antigos so encadeavam se o slot anterior chegasse mais
    // cedo (`faseT1.diasChegada <= dChegada`) e, quando nao chegava, desistiam
    // e recomecavam do stock cru — o que subestimava o stock sempre que as
    // datas estavam trocadas em relacao aos numeros dos slots. Agora a ordem
    // dos slots deixa de importar de todo.
    const fases = []
    let anterior = null
    for (const t of trans.filter(t => t.dias !== null && t.dias >= 0).sort((a, b) => a.dias - b.dias)) {
      const dChegada = t.dias
      const stockNaChegada = anterior
        ? Math.max(0, anterior.stockApos - vd * (dChegada - anterior.diasChegada))
        : stockRestanteNoDia(dChegada)
      const stockApos  = stockNaChegada + t.qtd
      const diasApos   = vd > 0 ? Math.floor(stockApos / vd) : 9999
      const diasEsgota = dChegada + diasApos
      const temRutura  = anterior ? anterior.diasEsgota < dChegada : diasSoStock < dChegada
      const fase = {
        n:               t.n,
        qtd:             t.qtd,
        chegada:         fmtDate(new Date(t.data)),
        diasChegada:     dChegada,
        stockNaChegada:  Math.round(stockNaChegada),
        stockApos:       Math.round(stockApos),
        diasEsgota,
        dataEsgota:      fmtDate(addDays(hoje, diasEsgota)),
        temRutura,
        diasRutura:      temRutura && !anterior ? dChegada - diasSoStock : 0,
      }
      fases.push(fase)
      anterior = fase
    }

    // diasTotal = capacidade real de cobertura (incluindo trânsitos)
    // dataEsgotarTotal = data prevista do esgotamento FINAL (depois de todos os trânsitos)
    // Usado para "Encomendar até" — recomendação de quando colocar nova encomenda
    const diasComTransito = fases.length ? fases[fases.length - 1].diasEsgota : diasSoStock
    const dataPrevistaComTransito = addDays(hoje, diasComTransito)

    const diasTotal = diasComTransito
    const dataEsgotarTotal = dataPrevistaComTransito

    const dataLimite = addDays(dataEsgotarTotal, -lt)
    const diasAteEncomenda = Math.floor((dataLimite - hoje) / 86400000)

    // Trânsitos com data já passada: NÃO entram na projecção (não temos essa mercadoria),
    // mas também não podem desaparecer em silêncio — senão o sistema sugere encomendar
    // outra vez o que já vem a caminho. Ficam listados como atraso.
    const atrasados = trans
      .filter(t => t.qtd > 0 && t.data && t.dias !== null && t.dias < 0)
      .map(t => ({ n: t.n, qtd: t.qtd, data: fmtDate(new Date(t.data)), diasAtraso: Math.abs(t.dias) }))
    const qtdAtrasada = atrasados.reduce((s, a) => s + a.qtd, 0)

    const totalTransito = fases.reduce((s, f) => s + f.qtd, 0)
    const stockNecessario = vd > 0 ? Math.ceil(vd * oc) : 0
    const disponivel = sa + totalTransito
    const qtdSugerida = vd > 0 ? Math.max(0, stockNecessario - disponivel) : 0

    let status
    if (diasTotal <= 0)       status = 'critico'
    else if (diasTotal <= lt) status = 'critico'
    else if (diasTotal <= oc) status = 'alerta'
    else                      status = 'ok'

    const projecao = []
    let stockSim = sa
    for (let i = 0; i <= 60; i++) {
      // O slot 1 entra so a partir do dia seguinte e os outros entram no
      // proprio dia. E assim desde que isto foi escrito e fica como estava:
      // mexer-lhe mudava numeros ja mostrados, e isto e uma mudanca de slots e
      // nao de previsao. Vale a pena olhar-lhe um dia — um transito que chega
      // hoje conta na ficha e nao conta no grafico.
      for (const t of trans) {
        if (t.dias === null) continue
        if (t.n === 1 ? (t.dias > 0 && i === t.dias) : (t.dias >= 0 && i === t.dias)) stockSim += t.qtd
      }
      if (i % 2 === 0) projecao.push({ dia: i, stock: Math.round(Math.max(0, stockSim)) })
      if (stockSim > 0) stockSim -= vd
    }

    // As chaves por slot continuam a existir para quem as le fora daqui.
    const porSlot = {}
    for (const t of trans) {
      porSlot[`t${t.n}q`] = t.qtd
      porSlot[`t${t.n}d`] = t.data ? fmtDate(new Date(t.data)) : null
      porSlot[`diasAteT${t.n}`] = t.dias
      porSlot[`faseT${t.n}`] = fases.find(f => f.n === t.n) || null
    }

    return {
      vm, vd: vd.toFixed(2), lt, sa, oc,
      ...porSlot,
      fases,
      totalTransito, stockTotalDisponivel: sa + totalTransito,
      diasSoStock, diasTotal, diasAteEncomenda,
      diasComTransito,
      dataEsgotar:      fmtDate(dataEsgotar),
      dataEsgotarTotal: fmtDate(dataEsgotarTotal),
      dataPrevistaComTransito: fmtDate(dataPrevistaComTransito),
      dataLimite:       fmtDate(dataLimite),
      qtdSugerida, stockNecessario,
      temTransito: fases.length > 0,
      atrasados, qtdAtrasada,
      status, projecao,
      et: totalTransito, diasFinal: diasTotal,
      dataFinal: diasTotal < 9999 ? fmtDate(dataEsgotarTotal) : null,
    }
  }

  // Catorze dias chegam: mostra-se a fotografia mais recente de cada pais e
  // compara-se com a anterior para dizer se o stock do concorrente esta a subir
  // ou a descer. E a descida que interessa — e ela que diz quando o pais volta.
  useEffect(() => {
    const ean = String(selected?.EAN || '').trim()
    if (!ean) { setBuybox([]); setBuyboxErro(''); return }
    let cancelado = false
    ;(async () => {
      const desde = new Date(Date.now() - 14 * 86400000).toISOString().slice(0, 10)
      const { data, error } = await supabase.from('buybox_historico')
        .select('data, storefront, preco_cents, moeda, vendedor, stock, sou_eu, url')
        .eq('ean', ean).gte('data', desde).order('data', { ascending: false })
      if (cancelado) return
      if (error) { setBuybox([]); setBuyboxErro(error.message); return }
      setBuyboxErro('')
      supabase.from('produto_comparador').select('storefront, url').eq('ean', ean)
        .then(({ data: rs }) => {
          if (cancelado) return
          setLinksPais(Object.fromEntries((rs || []).map(r => [r.storefront, r.url])))
        })
      // Vem ordenado por data descendente, portanto a primeira linha de cada
      // pais e a mais recente.
      const porPais = new Map()
      for (const r of (data || [])) {
        if (!porPais.has(r.storefront)) porPais.set(r.storefront, [])
        porPais.get(r.storefront).push(r)
      }
      setBuybox([...porPais.entries()].map(([sf, serie]) => {
        const hoje = serie[0]
        // ── O RITMO SO CONTA ENQUANTO FOR O MESMO VENDEDOR ────────────────
        //
        // A tabela guarda quem tem a Buy Box, e so esse. Se ela mudar de maos,
        // a serie salta do stock de um vendedor para o de outro — e a
        // "descida" que daria era a diferenca entre dois armazens diferentes,
        // que nao e venda nenhuma. Num caso real isso apareceria como cem
        // unidades vendidas num dia.
        //
        // Por isso anda-se para tras SO enquanto o vendedor for o mesmo, e
        // reinicia-se quando muda. Fica com buracos; um numero inventado nesses
        // dias era pior do que nao haver numero.
        let maisAntiga = hoje
        for (const r of serie) {
          if (r.vendedor !== hoje.vendedor) break
          maisAntiga = r
        }
        let ritmo = null, diasRitmo = 0
        if (maisAntiga !== hoje && maisAntiga.stock != null && hoje.stock != null) {
          const dias = Math.round((new Date(maisAntiga.data + 'T00:00:00') - new Date(hoje.data + 'T00:00:00')) / -86400000)
          if (dias > 0) {
            diasRitmo = dias
            ritmo = Math.round(((Number(maisAntiga.stock) - Number(hoje.stock)) / dias) * 100) / 100
          }
        }
        return { sf, hoje, antes: serie[1] || null, ritmo, diasRitmo }
      }))
    })()
    return () => { cancelado = true }
  }, [selected?.EAN])

  const m = calc()
  const statusCfg = {
    ok:      { label: 'Stock Seguro',         color: C.success, bg: C.successSoft, Icon: CheckCircle },
    alerta:  { label: 'Considerar Encomenda', color: C.warning, bg: C.warningSoft, Icon: AlertTriangle },
    critico: { label: 'Encomendar Urgente',   color: C.danger,  bg: C.dangerSoft,  Icon: AlertTriangle },
  }
  const sc = m ? statusCfg[m.status] : statusCfg.ok
  const clienteNome = clientes.find(c => c.email === form.Email_Cliente)?.nome

  const enviarEmailManual = async () => {
    if (!selected?.id) return
    setEnviandoEmail(true)
    setEmailMsg({ tipo: '', texto: '' })
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const res = await fetch(`${SUPABASE_URL}/functions/v1/check-stock-alerts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session?.access_token}` },
        body: JSON.stringify({ modo: 'manual', produto_id: selected.id })
      })
      const json = await res.json()
      if (json.ok) {
        setEmailMsg({ tipo: 'ok', texto: `Email enviado para ${json.para} (stock: ${json.dias} dias restantes)` })
        await loadProdutos()
      } else {
        setEmailMsg({ tipo: 'erro', texto: 'Erro: ' + (json.erro || 'desconhecido') })
      }
    } catch (e) {
      setEmailMsg({ tipo: 'erro', texto: 'Erro: ' + (e?.message || String(e)) })
    }
    setEnviandoEmail(false)
    setTimeout(() => setEmailMsg({ tipo: '', texto: '' }), 6000)
  }

  const sincronizarLognow = async () => {
    setSincronizandoLognow(true)
    setErrorMsg('')
    setSuccessMsg('')
    try {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('Sem sessão activa')
      const res = await fetch(`${SUPABASE_URL}/functions/v1/sync-lognow-stock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({}),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        throw new Error(data?.error || `HTTP ${res.status}`)
      }
      const com = data?.with_stock ?? 0
      const sem = data?.without_match ?? 0
      await loadProdutos()
      setSuccessMsg(`LOGNOW sincronizado: ${com} com stock, ${sem} sem oferta correspondente.`)
    } catch (e) {
      setErrorMsg('Erro ao sincronizar LOGNOW: ' + (e?.message || String(e)))
    } finally {
      setSincronizandoLognow(false)
      setTimeout(() => setSuccessMsg(''), 6000)
    }
  }

  // Stock manual vs stock real da LOGNOW. Todo o planeamento (dias até esgotar,
  // quantidade a pedir, projecção) corre sobre Stock_Atual — se este divergir do
  // que está mesmo no armazém, as compras saem erradas sem ninguém dar por isso.
  const divergenciasStock = produtos
    .filter(p => p.stock_lognow != null && Number(p.stock_lognow) !== Number(p.Stock_Atual || 0))
    .map(p => ({
      nome: p.Nome,
      manual: Number(p.Stock_Atual || 0),
      lognow: Number(p.stock_lognow),
      diff: Number(p.stock_lognow) - Number(p.Stock_Atual || 0),
    }))
    .sort((a, b) => Math.abs(b.diff) - Math.abs(a.diff))

  const produtosFiltrados = (() => {
    const q = searchProduto.trim().toLowerCase()
    if (!q) return produtos
    return produtos.filter(p => {
      const nome = String(p.Nome || '').toLowerCase()
      const ean = String(p.EAN || '').toLowerCase()
      if (nome.includes(q) || ean.includes(q)) return true
      if (!isReadOnly) {
        const emailCliente = String(p.Email_Cliente || '').toLowerCase()
        const clienteNome = (clientes.find(c => c.email === p.Email_Cliente)?.nome || '').toLowerCase()
        if (emailCliente.includes(q) || clienteNome.includes(q)) return true
      }
      return false
    })
  })()

  return (
    <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

      {/* ── Sidebar produtos ── */}
      <aside style={{
        width: isMobile ? (selected ? 0 : '100%') : '280px',
        display: isMobile && selected ? 'none' : 'flex',
        backgroundColor: C.surface,
        borderRight: isMobile ? 'none' : `1px solid ${C.border}`,
        flexDirection: 'column',
        flexShrink: 0,
        overflowY: 'auto',
      }}>
        <div style={{ padding: '14px 16px 4px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: '11px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '0.8px' }}>
            Produtos {searchProduto.trim() ? `(${produtosFiltrados.length}/${produtos.length})` : `(${produtos.length})`}
          </span>
          {!isReadOnly && (
            <button onClick={() => setShowNovoProduto(true)} title="Novo Produto"
              style={{ width: '24px', height: '24px', borderRadius: '6px', backgroundColor: C.primary, border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Plus size={14} color={C.primaryText} />
            </button>
          )}
        </div>

        {/* Stock manual != stock real da LOGNOW — o planeamento corre sobre o manual */}
        {!isReadOnly && divergenciasStock.length > 0 && (
          <div style={{ margin: '6px 12px 4px', padding: '8px 10px', background: C.warningSoft, border: `1px solid ${C.warning}`, borderRadius: '6px' }}>
            <button onClick={() => setVerDivergencias(v => !v)}
              style={{ width: '100%', border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, textAlign: 'left', fontSize: '11px', fontWeight: '800', color: '#92400e', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
              <span>⚠ {divergenciasStock.length} produto(s) com stock diferente do LOGNOW</span>
              <span>{verDivergencias ? '▲' : '▼'}</span>
            </button>
            {verDivergencias && (
              <div style={{ marginTop: '6px', maxHeight: '160px', overflowY: 'auto' }}>
                {divergenciasStock.map(d => (
                  <div key={d.nome} title={d.nome}
                    style={{ fontSize: '10.5px', color: '#7c2d12', padding: '3px 0', borderTop: `1px solid ${C.warning}40`, display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.nome}</span>
                    <span style={{ whiteSpace: 'nowrap', fontWeight: '700' }}>
                      {d.manual} → {d.lognow} <span style={{ color: d.diff > 0 ? C.success : C.danger }}>({d.diff > 0 ? '+' : ''}{d.diff})</span>
                    </span>
                  </div>
                ))}
                <p style={{ margin: '6px 0 0', fontSize: '10px', color: '#92400e', lineHeight: '1.5' }}>
                  As contas de compra usam o <strong>stock manual</strong>. Corrige-o antes de encomendar, ou sincroniza com o LOGNOW.
                </p>
              </div>
            )}
          </div>
        )}

        {/* Pesquisa */}
        <div style={{ padding: '8px 14px 12px' }}>
          <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', display: 'flex', color: C.textMuted }}>
              <Search size={12} />
            </span>
            <input
              type="text"
              value={searchProduto}
              onChange={e => setSearchProduto(e.target.value)}
              placeholder={isReadOnly ? 'Procurar nome ou EAN…' : 'Procurar nome, EAN ou cliente…'}
              style={{ width: '100%', height: '32px', padding: '0 28px 0 30px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '12px', backgroundColor: C.surface, color: C.text, outline: 'none', boxSizing: 'border-box' }}
            />
            {searchProduto && (
              <button
                onClick={() => setSearchProduto('')}
                title="Limpar"
                style={{ position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', width: '18px', height: '18px', border: 'none', background: C.surfaceAlt, borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.textMuted }}>
                <X size={11} />
              </button>
            )}
          </div>
        </div>

        {loading ? (
          <div style={{ padding: '16px', color: C.textMuted, fontSize: '13px' }}>A carregar…</div>
        ) : produtos.length === 0 ? (
          <div style={{ padding: '24px 16px', textAlign: 'center', color: C.textMuted, fontSize: '12px' }}>
            <Package size={28} style={{ opacity: 0.3, margin: '0 auto 8px', display: 'block' }} />
            {isReadOnly ? 'Nenhum produto associado à sua conta.' : 'Sem produtos.'}
          </div>
        ) : produtosFiltrados.length === 0 ? (
          <div style={{ padding: '24px 16px', textAlign: 'center', color: C.textMuted, fontSize: '12px' }}>
            Sem resultados para “{searchProduto}”.
          </div>
        ) : produtosFiltrados.map((p) => {
          const isSelected = selected?.Nome === p.Nome
          const hasCritical = !!p.alerta_critico_em
          const hasWarning = !hasCritical && !!p.alerta_aviso_em
          const accentColor = isSelected ? C.accent : hasCritical ? C.danger : hasWarning ? C.warning : 'transparent'
          const clienteNome = clientes.find(c => c.email === p.Email_Cliente)?.nome
          const precoBase = Number(p.preco)
          const bgBase = isSelected
            ? '#fffbeb'
            : hasCritical ? C.dangerSoft
            : hasWarning  ? C.warningSoft
            : 'transparent'
          const bgHover = isSelected
            ? '#fef3c7'
            : hasCritical ? '#fecaca'
            : hasWarning  ? '#fde68a'
            : C.surfaceAlt
          const dotColor = p.categoria === 'perfumes' ? '#9c27b0'
                         : p.categoria === 'cosmeticos' ? '#00bcd4'
                         : 'transparent'
          const inicial = (p.Nome || '?').trim().charAt(0).toUpperCase()
          return (
            <button
              key={p.Nome}
              onClick={() => selectProduto(p)}
              onMouseEnter={ev => { ev.currentTarget.style.background = bgHover }}
              onMouseLeave={ev => { ev.currentTarget.style.background = bgBase }}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: '10px',
                padding: '10px 14px',
                border: 'none',
                borderLeft: `3px solid ${accentColor}`,
                borderBottom: `1px solid ${C.border}`,
                width: '100%',
                textAlign: 'left',
                background: bgBase,
                cursor: 'pointer',
                transition: 'background 0.12s',
              }}>
              <div style={{
                width: '36px', height: '36px', flexShrink: 0,
                borderRadius: '6px', overflow: 'hidden',
                background: C.surfaceAlt,
                border: `1px solid ${C.border}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {p.foto_url ? (
                  <img src={p.foto_url} alt=""
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={ev => {
                      ev.currentTarget.style.display = 'none'
                      const fb = ev.currentTarget.nextElementSibling
                      if (fb) fb.style.display = 'flex'
                    }} />
                ) : null}
                <span style={{
                  display: p.foto_url ? 'none' : 'flex',
                  width: '100%', height: '100%',
                  alignItems: 'center', justifyContent: 'center',
                  fontSize: '14px', fontWeight: '700', color: C.textFaint,
                }}>{inicial}</span>
              </div>

              <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'flex-start', gap: '6px' }}>
                  <span style={{ fontSize: '13px', fontWeight: '600', color: C.text, lineHeight: '1.35', display: 'flex', alignItems: 'center', gap: '6px', minWidth: 0 }}>
                    {dotColor !== 'transparent' && (
                      <span title={p.categoria === 'perfumes' ? 'Perfume' : 'Cosmético'}
                        style={{ width: '7px', height: '7px', borderRadius: '50%', background: dotColor, flexShrink: 0 }} />
                    )}
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.Nome}</span>
                  </span>
                  {(hasCritical || hasWarning) && (
                    <span style={{ flexShrink: 0, padding: '1px 7px', borderRadius: '10px', fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.3px', backgroundColor: hasCritical ? C.dangerSoft : C.warningSoft, color: hasCritical ? C.danger : C.warning }}>
                      {hasCritical ? 'Crítico' : 'Aviso'}
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px', fontSize: '11px', color: C.textMuted }}>
                  <span><strong style={{ color: C.text, fontWeight: '700' }}>{fmtInt(p.Stock_Atual)}</strong> un.</span>
                  <span style={{ color: C.borderStrong }}>·</span>
                  <span>{fmt(precoBase)} € s/IVA</span>
                </div>
                {!isReadOnly && clienteNome && (
                  <div style={{ fontSize: '10px', color: C.textFaint, marginTop: '3px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <User size={9} /> {clienteNome}
                  </div>
                )}
              </div>
            </button>
          )
        })}

        <div style={{ flex: 1 }} />
        {isReadOnly && (
          <div style={{ padding: '10px 12px', margin: '8px 12px 12px', backgroundColor: C.warningSoft, border: `1px solid ${C.warning}40`, borderRadius: '6px' }}>
            <div style={{ fontSize: '11px', color: C.warning, fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Shield size={11} /> Modo leitura
            </div>
          </div>
        )}
        <div style={{ padding: '10px 14px', borderTop: `1px solid ${C.border}`, fontSize: '10px', color: C.textMuted, display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Shield size={10} /> Dados seguros · Supabase
        </div>
      </aside>

      {/* ── Main ── */}
      <main style={{
        flex: 1,
        overflowY: 'auto',
        padding: isMobile ? '16px 12px' : '24px 28px',
        display: isMobile && !selected ? 'none' : 'flex',
        flexDirection: 'column',
        gap: '20px',
        backgroundColor: C.bg,
      }}>
        {!selected ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: C.textMuted, gap: '12px' }}>
            <Package size={48} style={{ opacity: 0.3 }} />
            <p style={{ fontSize: '16px', margin: 0 }}>
              {isReadOnly ? 'Nenhum produto associado à sua conta.' : 'Selecione um produto na barra lateral'}
            </p>
          </div>
        ) : (
          <>
            {isMobile && (
              <button
                onClick={() => setSelected(null)}
                style={{ alignSelf: 'flex-start', padding: '6px 12px', height: '34px', border: `1px solid ${C.border}`, borderRadius: '6px', background: C.surface, cursor: 'pointer', color: C.text, fontSize: '13px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}>
                ← Voltar à lista
              </button>
            )}
            {/* Topo */}
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: C.textMuted, marginBottom: '4px' }}>
                  <span>Gestão de Stock</span><ChevronRight size={11} />
                  <span style={{ color: C.text, fontWeight: '700' }}>{form.Nome}</span>
                  {isReadOnly && <span style={{ marginLeft: '8px', padding: '1px 8px', backgroundColor: C.accent, color: C.accentText, borderRadius: '10px', fontSize: '11px', fontWeight: '700' }}>● Os seus produtos</span>}
                </div>
                <h1 style={{ fontSize: '22px', fontWeight: '700', color: C.text, margin: 0 }}>{form.Nome}</h1>
                <p style={{ fontSize: '13px', color: C.textMuted, margin: '4px 0 0', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '2px' }}>
                    EAN: {form.EAN || '—'}
                    {form.EAN && <CopyButton text={form.EAN} size={11} title="Copiar EAN" />}
                  </span>
                  · Contagem: {fmtDate(form.Data_Contagem)}
                  {form.Email_Cliente && (
                    <span style={{ padding: '1px 8px', backgroundColor: C.surfaceAlt, color: C.text, borderRadius: '10px', fontSize: '11px', fontWeight: '600', border: `1px solid ${C.border}` }}>
                      Cliente: {clienteNome || form.Email_Cliente}
                    </span>
                  )}
                  {selected?.alerta_critico_em && (
                    <span style={{ padding: '1px 10px', backgroundColor: C.dangerSoft, color: C.danger, borderRadius: '10px', fontSize: '11px', fontWeight: '700', border: `1px solid ${C.danger}40` }}>
                      🚨 Email crítico enviado em {fmtDate(new Date(selected.alerta_critico_em))}
                    </span>
                  )}
                  {!selected?.alerta_critico_em && selected?.alerta_aviso_em && (
                    <span style={{ padding: '1px 10px', backgroundColor: C.warningSoft, color: C.warning, borderRadius: '10px', fontSize: '11px', fontWeight: '700', border: `1px solid ${C.warning}40` }}>
                      ⚠ Email de aviso enviado em {fmtDate(new Date(selected.alerta_aviso_em))}
                    </span>
                  )}
                </p>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '4px', flexWrap: 'wrap' }}>
                  {!isReadOnly && (
                    <button onClick={sincronizarLognow} disabled={sincronizandoLognow}
                      title="Sincronizar Stock Atual com a quantidade disponível na LOGNOW"
                      style={{ height: '34px', padding: '0 14px', backgroundColor: C.surface, color: C.text, border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: sincronizandoLognow ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, opacity: sincronizandoLognow ? 0.7 : 1 }}>
                      <RefreshCw size={13} style={sincronizandoLognow ? { animation: 'spin 1s linear infinite' } : {}} />
                      {sincronizandoLognow ? 'A sincronizar...' : 'Sincronizar LOGNOW'}
                    </button>
                  )}
                  {!isReadOnly && form.Email_Cliente && (
                    <button onClick={enviarEmailManual} disabled={enviandoEmail}
                      title={`Enviar email de alerta de stock para ${form.Email_Cliente}`}
                      style={{ height: '34px', padding: '0 14px', backgroundColor: enviandoEmail ? C.surfaceAlt : C.warningSoft, color: C.warning, border: `1px solid ${C.warning}`, borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: enviandoEmail ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, opacity: enviandoEmail ? 0.7 : 1 }}>
                      <Send size={13} /> {enviandoEmail ? 'A enviar...' : 'Enviar Email ao Cliente'}
                    </button>
                  )}
                  <button onClick={() => setEditMode(true)}
                    style={{ height: '34px', padding: '0 16px', backgroundColor: C.primary, color: C.primaryText, border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0, letterSpacing: '0.02em' }}>
                    <Settings size={13} /> {isReadOnly ? 'Detalhes' : 'Editar Produto'}
                  </button>
                </div>
            </div>

            {/* CTA cliente — Adicionar ao carrinho (linha dedicada, posição fixa para todos os produtos) */}
            {isReadOnly && (
              <div style={{ backgroundColor: '#fffbeb', border: `1px solid ${C.accentDark}`, borderRadius: '8px', padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: '200px' }}>
                  <ShoppingCart size={18} color={C.accentDark} />
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: C.text }}>
                      {m.qtdSugerida > 0 ? `Recomendamos pedir ${m.qtdSugerida} unidades` : 'Stock suficiente neste momento'}
                    </div>
                    <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '2px' }}>
                      {m.qtdSugerida > 0
                        ? (m.diasAteEncomenda < 0 ? `⚠ Encomenda atrasada — repor agora` : `para garantir ${m.oc} dias de cobertura até ${m.dataLimite}`)
                        : 'Mas podes encomendar de qualquer forma se quiseres reforçar o stock'}
                    </div>
                  </div>
                </div>
                <button onClick={() => { setQtdAdd(m.qtdSugerida > 0 ? m.qtdSugerida : (perfilEfectivo?.qtd_minima_compra || selected?.qtd_minima_compra || 10)); setPopoverAdd({ produto: selected, qtdSugerida: m.qtdSugerida }) }}
                  style={{ height: '40px', padding: '0 18px', backgroundColor: C.accent, color: C.accentText, border: `1px solid ${C.accentDark}`, borderRadius: '6px', fontSize: '13px', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, letterSpacing: '0.02em', boxShadow: '0 2px 6px rgba(250,204,21,0.4)' }}>
                  <ShoppingCart size={15} />
                  {m.qtdSugerida > 0 ? `Adicionar ${m.qtdSugerida} un ao carrinho` : 'Adicionar ao carrinho'}
                </button>
              </div>
            )}

            {errorMsg && <div style={{ padding: '10px 14px', backgroundColor: C.dangerSoft, borderLeft: `4px solid ${C.danger}`, borderRadius: '6px', color: C.danger, fontSize: '13px' }}>{errorMsg}</div>}
            {successMsg && <div style={{ padding: '10px 14px', backgroundColor: C.successSoft, borderLeft: `4px solid ${C.success}`, borderRadius: '6px', color: C.success, fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}><CheckCircle size={14} />{successMsg}</div>}
            {emailMsg.texto && (
              <div style={{ padding: '10px 14px', backgroundColor: emailMsg.tipo === 'ok' ? C.successSoft : C.dangerSoft, borderLeft: `4px solid ${emailMsg.tipo === 'ok' ? C.success : C.danger}`, borderRadius: '6px', color: emailMsg.tipo === 'ok' ? C.success : C.danger, fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                {emailMsg.tipo === 'ok' ? <CheckCircle size={14} /> : <AlertTriangle size={14} />} {emailMsg.texto}
              </div>
            )}

            {m && (
              <>
                {/* KPIs */}
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(5, 1fr)', gap: '14px' }}>
                  <KpiCard label="Stock Atual" value={`${m.sa} unid`} icon={Package} color={C.text} />
                  <KpiCard
                    label="Vendas Diárias"
                    value={`${m.vd} unid`}
                    icon={TrendingUp}
                    color="#6264a7"
                    subtitle={!isReadOnly ? (() => {
                      if (selected?.vendas_mensais_manual) return '✎ manual · introduzido por admin'
                      const calcEm = selected?.vendas_mensais_calculadas_em
                      const diasDados = Number(selected?.vendas_mensais_dias_dados || 0)
                      if (!calcEm) return '⊙ estimada · sem histórico LOGNOW ainda'
                      // Janela: dia mais antigo com dados = hoje - diasDados
                      const inicio = new Date(); inicio.setDate(inicio.getDate() - diasDados)
                      const inicioFmt = fmtDate(inicio)
                      if (diasDados >= 7) return `auto · ${diasDados} dias de dados (desde ${inicioFmt})`
                      return `auto · poucos dados: ${diasDados}d (desde ${inicioFmt})`
                    })() : undefined}
                  />
                  <KpiCard label="Dias até Esgotar" value={`${m.diasFinal} dias`} icon={Clock} color={m.status === 'critico' ? C.danger : m.status === 'alerta' ? C.warning : C.success} />
                  {(() => {
                    const corTransito = '#00b7c3'
                    // Ja vem ordenado por data de chegada, nao por numero de slot.
                    const chegadas = m.fases.map(f => ({ n: f.n, qtd: f.qtd, data: f.chegada }))
                    return (
                      <div style={{ backgroundColor: C.surface, borderRadius: '10px', padding: '16px 20px', border: `1px solid ${C.border}`, boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                          <span style={{ fontSize: '11px', color: C.textMuted, fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Em Trânsito</span>
                          <Truck size={16} color={corTransito} />
                        </div>
                        <div style={{ fontSize: '22px', fontWeight: '700', color: corTransito }}>{m.et} unid</div>
                        {chegadas.length > 0 && (
                          <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '3px', paddingTop: '8px', borderTop: `1px dashed ${C.border}` }}>
                            {chegadas.map(c => (
                              <div key={c.n} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '11px' }}>
                                <span style={{ color: C.textMuted, fontWeight: '600' }}>Chegada {c.n}</span>
                                <span style={{ color: C.text, fontWeight: '600' }}>{c.qtd} un · <span style={{ color: corTransito }}>{c.data}</span></span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )
                  })()}
                  <KpiCard
                    label="Stock LOGNOW"
                    value={selected?.stock_lognow == null ? '—' : `${selected.stock_lognow} unid`}
                    icon={Database}
                    color={selected?.stock_lognow == null ? C.textMuted : (selected.stock_lognow > 0 ? C.info : C.danger)}
                    subtitle={selected?.stock_lognow_atualizado_em
                      ? `🔄 ${new Date(selected.stock_lognow_atualizado_em).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
                      : 'sem data de sincronização'}
                  />
                </div>

                {/* Banner status */}
                <div style={{ padding: '14px 18px', backgroundColor: sc.bg, borderLeft: `4px solid ${sc.color}`, borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <sc.Icon size={20} color={sc.color} />
                  <div>
                    <div style={{ fontWeight: '700', fontSize: '14px', color: sc.color }}>{sc.label}</div>
                    <div style={{ fontSize: '13px', color: C.textMuted, marginTop: '2px' }}>
                      {m.status === 'ok' && `Stock suficiente para ${m.diasFinal} dias (objetivo: ${m.oc} dias).`}
                      {m.status === 'alerta' && `Stock esgota em ${m.diasFinal} dias. Encomendar antes de ${m.dataLimite}.`}
                      {m.status === 'critico' && `Stock esgota em ${m.diasFinal} dias. Lead time: ${m.lt} dias. Encomendar IMEDIATAMENTE.`}
                    </div>
                  </div>
                </div>

                {/* BUY BOX POR PAIS — onde vale a pena pôr as unidades.
                    Ordenado pelo preco e nao pelo pais: a primeira linha e onde
                    a proxima unidade rende mais, que e a unica ordem que
                    responde a pergunta. Os precos ficam na moeda de origem; ver
                    o comentario da tabela no SQL. */}
                {buybox.length > 0 && (
                  <div style={{ backgroundColor: C.surface, borderRadius: '10px', border: `1px solid ${C.border}`, padding: '18px 20px', marginBottom: '20px', boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                      <h3 style={{ fontSize: '14px', fontWeight: '700', color: C.text, margin: 0 }}>Buy Box por país</h3>
                      <span style={{ fontSize: '11px', color: C.textFaint }}>
                        {(() => {
                          const d = buybox.map(b => b.hoje?.data).filter(Boolean).sort().at(-1)
                          if (!d) return null
                          const dias = Math.round((Date.now() - new Date(d + 'T00:00:00').getTime()) / 86400000)
                          return dias <= 0 ? 'actualizado hoje'
                            : dias === 1 ? 'actualizado ontem'
                            : `actualizado há ${dias} dias`
                        })()}
                      </span>
                    </div>

                    <div style={{ overflowX: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' }}>
                        <thead>
                          <tr style={{ textAlign: 'left', color: C.textMuted, fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.6px' }}>
                            <th style={{ padding: '6px 8px 6px 0' }}>País</th>
                            <th style={{ padding: '6px 8px', textAlign: 'right' }}>Buy Box</th>
                            <th style={{ padding: '6px 8px' }}>De quem</th>
                            <th style={{ padding: '6px 8px', textAlign: 'right' }}>Stock dele</th>
                            <th style={{ padding: '6px 8px' }}>Ritmo</th>
                            <th style={{ padding: '6px 0 6px 8px' }}>Ver preços do país</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[...buybox].sort((a, b) => {
                            // Euros primeiro e por valor decrescente. As moedas
                            // estrangeiras vao para o fim em vez de serem
                            // convertidas por uma taxa que nao temos.
                            const ea = a.hoje?.moeda === 'EUR', eb = b.hoje?.moeda === 'EUR'
                            if (ea !== eb) return ea ? -1 : 1
                            return Number(b.hoje?.preco_cents || 0) - Number(a.hoje?.preco_cents || 0)
                          }).map(({ sf, hoje, antes, ritmo, diasRitmo }) => {
                            const nomePais = { de: 'Alemanha', at: 'Áustria', fr: 'França', it: 'Itália', sk: 'Eslováquia', cz: 'Chéquia', pl: 'Polónia', nl: 'Países Baixos', es: 'Espanha' }[sf] || sf.toUpperCase()
                            const simbolo = { EUR: '€', CZK: 'Kč', PLN: 'zł' }[hoje?.moeda] || ''
                            const preco = hoje?.preco_cents == null ? '—'
                              : (Number(hoje.preco_cents) / 100).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + simbolo
                            const delta = (hoje?.stock != null && antes?.stock != null) ? Number(hoje.stock) - Number(antes.stock) : null
                            return (
                              <tr key={sf} style={{ borderTop: `1px solid ${C.border}`, background: hoje?.sou_eu ? (C.successSoft || 'transparent') : 'transparent' }}>
                                <td style={{ padding: '8px 8px 8px 0', fontWeight: '600', color: C.text }}>
                                  {hoje?.url
                                    ? <a href={hoje.url} target="_blank" rel="noreferrer" style={{ color: C.text, textDecoration: 'none', borderBottom: `1px dotted ${C.border}` }}>{nomePais}</a>
                                    : nomePais}
                                </td>
                                <td style={{ padding: '8px', textAlign: 'right', fontWeight: '700', color: C.text, whiteSpace: 'nowrap' }}>{preco}</td>
                                <td style={{ padding: '8px', color: hoje?.sou_eu ? C.success : C.textMuted, fontWeight: hoje?.sou_eu ? '700' : '400' }}>
                                  {hoje?.sou_eu ? 'é tua' : (hoje?.vendedor || '—')}
                                </td>
                                <td style={{ padding: '8px', textAlign: 'right', color: C.textMuted }}>{hoje?.stock == null ? '—' : hoje.stock}</td>
                                <td style={{ padding: '8px', whiteSpace: 'nowrap', color: ritmo == null ? C.textFaint : ritmo > 0 ? C.success : C.textFaint }}
                                    title={ritmo == null ? 'Preciso de dois dias com o mesmo vendedor' : `Medido em ${diasRitmo} dia${diasRitmo === 1 ? '' : 's'}`}>
                                  {ritmo == null
                                    ? (delta == null ? '—' : delta === 0 ? 'sem mexer' : (delta > 0 ? '+' : '') + delta + ' un')
                                    : ritmo <= 0 ? 'parado'
                                    : ritmo.toLocaleString('pt-PT', { maximumFractionDigits: 1 }) + ' un/dia'}
                                </td>
                                {/* Abre o comparador desse pais na ficha
                                    do produto. Colado, nao deduzido — ver o
                                    comentario no topo do ficheiro. */}
                                <td style={{ padding: '8px 0 8px 8px', whiteSpace: 'nowrap' }}>
                                  {(() => {
                                    // Sem link colado nao se mostra nada. Um
                                    // link deduzido que abre na pagina errada e
                                    // pior do que a ausencia dele.
                                    const dado = linksPais[sf]
                                    if (!dado) return <span style={{ color: C.textFaint }}>—</span>
                                    const lido = lerLinkComparador(dado)
                                    return (
                                      <a href={dado} target="_blank" rel="noreferrer"
                                        title={dado}
                                        style={{ color: C.primary, textDecoration: 'none', fontWeight: '600', fontSize: '11.5px' }}>
                                        {lido?.nome || 'Ver'}
                                      </a>
                                    )
                                  })()}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* A leitura que o quadro serve para dar, escrita por extenso
                        para nao depender de quem olha saber fazê-la. */}
                    {(() => {
                      const outros = buybox.filter(b => b.hoje && !b.hoje.sou_eu && b.hoje.stock != null)
                      if (outros.length === 0) return (
                        <div style={{ fontSize: '11.5px', color: C.textMuted, marginTop: '10px', lineHeight: 1.55 }}>
                          Tens a Buy Box em todos os países medidos. Baixar preço aqui não te ganha quota
                          nenhuma — já a tens toda; só te ganha a procura extra que aparecer por ser mais barato.
                        </div>
                      )
                      const pior = outros.slice().sort((a, b) => Number(b.hoje.stock) - Number(a.hoje.stock))[0]
                      const ritmo = pior.ritmo
                      return (
                        <div style={{ fontSize: '11.5px', color: C.textMuted, marginTop: '10px', lineHeight: 1.55 }}>
                          Em <strong style={{ color: C.text }}>{({ de: 'Alemanha', at: 'Áustria', fr: 'França', it: 'Itália', sk: 'Eslováquia', cz: 'Chéquia', pl: 'Polónia', nl: 'Países Baixos', es: 'Espanha' }[pior.sf] || pior.sf.toUpperCase())}</strong>
                          {' '}a Buy Box é de <strong style={{ color: C.text }}>{pior.hoje.vendedor || 'outro vendedor'}</strong>,
                          {' '}com <strong style={{ color: C.text }}>{pior.hoje.stock} unidades</strong>.
                          {ritmo != null && ritmo > 0 ? (
                            <> Está a sair a {ritmo.toLocaleString('pt-PT', { maximumFractionDigits: 1 })} un/dia — a esse ritmo esgota em <strong style={{ color: C.text }}>{Math.ceil(Number(pior.hoje.stock) / ritmo)} dias</strong>.</>
                          ) : ritmo != null ? (
                            <> Não desceu desde ontem — não contes com ele a esgotar tão cedo.</>
                          ) : (
                            <> Falta mais um dia de série para saber a que ritmo está a sair.</>
                          )}
                          {' '}Enquanto lá estiver, as unidades rendem mais nos países de cima desta tabela.
                        </div>
                      )
                    })()}

                    {/* COLAR O LINK DO COMPARADOR. O pais sai do dominio, e
                        por isso serve qualquer site — nao ha lista a manter. */}
                    <div style={{ marginTop: '10px', paddingTop: '9px', borderTop: `1px dashed ${C.border}`, display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: '11px', color: C.textMuted, whiteSpace: 'nowrap' }}>
                        Colar link de comparador:
                      </span>
                      <input
                        key={Object.keys(linksPais).length}
                        placeholder="cola o link e ele vai para o país do domínio — idealo.fr, heureka.cz, ceneo.pl…"
                        onBlur={async (ev) => {
                          const bruto = ev.target.value.trim()
                          const ean = String(selected?.EAN || '').trim()
                          if (!bruto || !ean) return
                          const lido = lerLinkComparador(bruto)
                          if (!lido) {
                            setBuyboxErro('Não reconheci o país desse link. Usa o endereço do site do país — .de, .fr, .cz…')
                            return
                          }
                          setGuardandoRef(true); setBuyboxErro('')
                          const { error } = await supabase.from('produto_comparador')
                            .upsert([{ ean, storefront: lido.sf, url: lido.url }], { onConflict: 'ean,storefront' })
                          setGuardandoRef(false)
                          if (error) { setBuyboxErro('Não consegui guardar: ' + error.message); return }
                          setLinksPais(m => ({ ...m, [lido.sf]: lido.url }))
                          ev.target.value = ''
                        }}
                        style={{ flex: 1, minWidth: '300px', padding: '5px 8px', border: `1px solid ${C.border}`, borderRadius: '3px', fontSize: '11px', fontFamily: FONT, color: C.text }} />
                      <span style={{ fontSize: '10px', color: C.textFaint, whiteSpace: 'nowrap' }}>
                        {guardandoRef ? 'a guardar…' : Object.keys(linksPais).length + ' de 9 países'}
                      </span>
                    </div>

                    <div style={{ fontSize: '10.5px', color: C.textFaint, marginTop: '8px', lineHeight: 1.5 }}>
                      Ter a Buy Box <strong>não é</strong> ser o mais barato do país. Os links abrem o comparador
                      mais usado em cada mercado, já com o EAN pesquisado — se o preço de lá for muito abaixo do teu,
                      o comprador vai lá e a Buy Box não te vale nada.
                    </div>

                    {buyboxErro && (
                      <div style={{ fontSize: '11px', color: C.danger, marginTop: '8px' }}>Não consegui ler o histórico: {buyboxErro}</div>
                    )}
                  </div>
                )}

                {/* Recomendações + Gráfico */}
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '300px 1fr', gap: '20px' }}>
                  <div style={{ backgroundColor: C.surface, borderRadius: '10px', border: `1px solid ${C.border}`, padding: '20px', boxShadow: '0 1px 2px rgba(0,0,0,0.03)', display: 'flex', flexDirection: 'column', gap: '0' }}>
                    <h3 style={{ fontSize: '14px', fontWeight: '700', color: C.text, margin: '0 0 14px', paddingBottom: '12px', borderBottom: `1px solid ${C.border}` }}>Análise & Recomendações</h3>

                    {/* Bloco: Stock atual */}
                    <p style={{ fontSize: '10px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 6px' }}>Stock disponível</p>
                    {[
                      { label: 'Stock em armazém',       value: `${m.sa} unid` },
                      { label: 'Vendas diárias',          value: `${m.vd} unid/dia` },
                      { label: 'Esgota (só armazém)',     value: `${m.dataEsgotar} (${m.diasSoStock === 9999 ? '∞' : m.diasSoStock + ' dias'})`,
                                                           color: m.diasSoStock <= m.lt ? C.danger : C.textMuted },
                    ].map(({ label, value, color }) => (
                      <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: `1px solid ${C.border}` }}>
                        <span style={{ fontSize: '12px', color: C.textMuted }}>{label}</span>
                        <span style={{ fontSize: '12px', fontWeight: '600', color: color || C.text }}>{value}</span>
                      </div>
                    ))}

                    {/* Bloco: Trânsito */}
                    <p style={{ fontSize: '10px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '12px 0 6px' }}>Encomendas a caminho</p>

                    {/* Trânsitos com data ultrapassada — não entram nas contas, mas têm de se ver */}
                    {m.atrasados.length > 0 && (
                      <div style={{ marginBottom: '8px', padding: '10px 12px', backgroundColor: C.dangerSoft, borderLeft: `3px solid ${C.danger}`, borderRadius: '6px' }}>
                        <div style={{ fontSize: '12px', fontWeight: '800', color: C.danger, marginBottom: '4px' }}>
                          ⚠ {m.atrasados.length === 1 ? 'Trânsito atrasado' : `${m.atrasados.length} trânsitos atrasados`} — {fmtInt(m.qtdAtrasada)} unidades
                        </div>
                        {m.atrasados.map(a => (
                          <div key={a.n} style={{ fontSize: '11px', color: C.text, marginBottom: '2px' }}>
                            Trânsito {a.n}: <strong>{fmtInt(a.qtd)} un</strong> previstas para {a.data} — <strong style={{ color: C.danger }}>{a.diasAtraso} {a.diasAtraso === 1 ? 'dia' : 'dias'} de atraso</strong>
                          </div>
                        ))}
                        <div style={{ fontSize: '11px', color: C.textMuted, marginTop: '6px', lineHeight: '1.5' }}>
                          Estas unidades <strong>não estão a ser contadas</strong> na projecção nem na quantidade a pedir — não as temos.
                          Confirma com o fornecedor antes de encomendar outra vez, para não pedires em duplicado.
                        </div>
                      </div>
                    )}

                    {m.temTransito ? (
                      <>
                        {/* Uma cor por chegada, pela ordem em que chegam. Eram tres
                            blocos escritos a mao com as cores la dentro; com cinco
                            slots passam a sair de uma paleta. */}
                        {m.fases.map((f, idx) => {
                          const paleta = [
                            { cor: C.info,    fundo: C.infoSoft },
                            { cor: '#6264a7', fundo: '#f3f0ff' },
                            { cor: C.warning, fundo: C.warningSoft },
                            { cor: '#00838f', fundo: '#e0f4f6' },
                            { cor: '#7b5ea7', fundo: '#f2edf9' },
                          ]
                          const { cor, fundo } = paleta[idx % paleta.length]
                          return (
                            <div key={f.n} style={{ marginBottom: '8px', padding: '10px 12px', backgroundColor: fundo, borderLeft: `3px solid ${cor}`, borderRadius: '6px' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                <span style={{ fontSize: '12px', fontWeight: '700', color: cor }}>
                                  {f.diasChegada <= 0 ? '✅ Chegou hoje' : `📦 Chega a ${f.chegada}`}
                                  <span style={{ fontWeight: '600', opacity: 0.75 }}> · trânsito {f.n}</span>
                                </span>
                                <span style={{ fontSize: '12px', fontWeight: '600', color: C.text }}>{fmtInt(f.qtd)} unidades</span>
                              </div>
                              {f.temRutura && (
                                <div style={{ fontSize: '11px', color: C.danger, fontWeight: '600', marginBottom: '4px' }}>
                                  {idx === 0
                                    ? `⚠ Atenção: o stock do armazém esgota antes desta entrada chegar (${m.dataEsgotar}).`
                                    : '⚠ Atenção: pode haver rutura antes desta entrada chegar.'}
                                </div>
                              )}
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '4px', borderTop: `1px solid ${cor}30` }}>
                                <span style={{ fontSize: '11px', color: C.textMuted }}>Com esta entrega, o stock dura até</span>
                                <span style={{ fontSize: '13px', fontWeight: '700', color: f.diasEsgota <= m.oc ? C.warning : C.success }}>{f.dataEsgota}</span>
                              </div>
                            </div>
                          )
                        })}
                        {m.fases.length > 1 && (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', backgroundColor: m.diasComTransito <= m.oc ? C.warningSoft : C.successSoft, borderRadius: '6px', marginTop: '4px' }}>
                            <span style={{ fontSize: '12px', color: C.text, fontWeight: '600' }}>📅 Stock + trânsito previstos até</span>
                            <span style={{ fontSize: '14px', fontWeight: '700', color: m.diasComTransito <= m.oc ? C.warning : C.success }}>{m.dataPrevistaComTransito}</span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div style={{ padding: '6px 0', borderBottom: `1px solid ${C.border}`, fontSize: '12px', color: C.textMuted }}>
                        {m.atrasados.length > 0 ? 'Sem encomendas a caminho dentro do prazo — ver atrasos acima.' : 'Sem encomendas a caminho.'}
                      </div>
                    )}

                    {/* Próxima encomenda */}
                    <p style={{ fontSize: '10px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '12px 0 6px' }}>Próxima encomenda</p>
                    {[
                      { label: 'Lead time fornecedor',    value: `${m.lt} dias` },
                      { label: 'Objetivo de cobertura',   value: `${m.oc} dias` },
                      { label: 'Stock necessário',         value: `${m.stockNecessario} unid` },
                      { label: '⚠ Encomendar até',        value: m.diasAteEncomenda < 0 ? 'JÁ ATRASADO!' : m.dataLimite,
                                                           color: m.diasAteEncomenda < 0 ? C.danger : m.diasAteEncomenda <= 7 ? C.warning : C.success, bold: true },
                      { label: '📦 Quantidade a pedir',   value: m.qtdSugerida > 0 ? `${m.qtdSugerida} unidades` : 'Stock suficiente',
                                                           color: m.qtdSugerida > 0 ? C.text : C.success, bold: true },
                    ].map(({ label, value, color, bold }) => (
                      <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: `1px solid ${C.border}` }}>
                        <span style={{ fontSize: '12px', color: C.textMuted }}>{label}</span>
                        <span style={{ fontSize: '12px', fontWeight: bold ? '700' : '600', color: color || C.text }}>{value}</span>
                      </div>
                    ))}

                    {m.qtdSugerida > 0 && (
                      <div style={{ marginTop: '12px', padding: '10px 12px', backgroundColor: m.diasAteEncomenda < 0 ? C.dangerSoft : C.accent + '30', borderRadius: '6px', fontSize: '12px', color: m.diasAteEncomenda < 0 ? C.danger : C.text, fontWeight: '600', lineHeight: '1.6' }}>
                        {m.diasAteEncomenda < 0
                          ? `⚠ Encomenda atrasada! Pedir ${m.qtdSugerida} unid imediatamente para garantir ${m.oc} dias de cobertura.`
                          : `Pedir ${m.qtdSugerida} unid até ${m.dataLimite} para garantir ${m.oc} dias de cobertura.`
                        }
                      </div>
                    )}
                  </div>

                  <div style={{ backgroundColor: C.surface, borderRadius: '10px', border: `1px solid ${C.border}`, padding: '20px', boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
                    <h3 style={{ fontSize: '14px', fontWeight: '700', color: C.text, margin: '0 0 16px' }}>Projeção de Stock — 60 dias</h3>
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart data={m.projecao} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke={C.border} />
                        <XAxis dataKey="dia" tick={{ fontSize: 11, fill: C.textMuted }} />
                        <YAxis tick={{ fontSize: 11, fill: C.textMuted }} />
                        <Tooltip contentStyle={{ backgroundColor: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '12px' }} formatter={(v) => [`${v} unid`, 'Stock']} labelFormatter={(l) => `Dia ${l}`} />
                        <ReferenceLine y={0} stroke={C.danger} strokeDasharray="4 2" />
                        <Line type="monotone" dataKey="stock" stroke={C.text} strokeWidth={2} dot={false} />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </main>

      {/* MODAL — EDITAR PRODUTO */}
      {editMode && selected && (
        <div
          style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={(e) => { if (e.target === e.currentTarget) { setEditMode(false); setModalPos({ x: 0, y: 0 }) } }}
        >
          <div style={{ backgroundColor: C.surface, borderRadius: '12px', border: `1px solid ${C.border}`, width: '100%', maxWidth: '860px', maxHeight: 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.25)', overflow: 'hidden', position: 'relative', transform: `translate(${modalPos.x}px, ${modalPos.y}px)`, transition: 'none' }}>

            <div style={{ padding: '18px 24px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <div onMouseDown={startDrag} style={{ cursor: 'grab', flex: 1, userSelect: 'none' }}>
                <h2 style={{ fontSize: '16px', fontWeight: '700', color: C.text, margin: '0 0 2px', display: 'flex', alignItems: 'center', gap: '8px', pointerEvents: 'none' }}>
                  <Settings size={16} color={C.text} /> {isReadOnly ? 'Detalhes do Produto' : 'Editar Produto'} <span style={{ fontSize: '10px', color: C.textMuted, fontWeight: '400', marginLeft: '4px' }}>(✥ arrastável)</span>
                </h2>
                <p style={{ fontSize: '12px', color: C.textMuted, margin: 0, pointerEvents: 'none' }}>{form.Nome}</p>
              </div>
              <button onClick={() => { setEditMode(false); setModalPos({ x: 0, y: 0 }) }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textMuted, padding: '6px', display: 'flex' }}>
                <X size={18} />
              </button>
            </div>

            {/* SCROLL NO CORPO, ALTURA MAXIMA NO CARTAO.
                A modal nao tinha nem uma coisa nem outra: crescia com o
                conteudo e, sendo centrada, o que passasse da altura do ecra
                saia por cima e por baixo sem forma de la chegar. Passar de tres
                para cinco slots de transito acrescentou dois blocos e um botao,
                e a partir dai o fundo ficou inalcancavel — arrastar a modal era
                o unico recurso, e isso e uma saida, nao uma solucao.
                O scroll vai numa div a volta e nao no proprio fieldset. Os
                browsers ignoram overflow em <fieldset> — poe-se la e nao
                acontece nada, que foi o que se viu a primeira tentativa: o
                cartao ja cabia no ecra mas o meio continuava sem rolar.
                O minHeight 0 tambem e obrigatorio: sem ele um filho de flex
                recusa-se a encolher abaixo do seu conteudo e o overflow nunca
                chega a acontecer. */}
            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
            <fieldset disabled={isReadOnly} style={{ padding: '24px', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '24px', border: 'none', margin: 0, minWidth: 0 }}>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                <div>
                  <p style={{ fontSize: '11px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` }}>Informação Geral</p>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <Field label="Nome">
                      <input value={form.Nome} readOnly style={{ width: '100%', height: '32px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surfaceAlt, color: C.textMuted, fontSize: '14px', boxSizing: 'border-box' }} />
                    </Field>
                    <Field label="EAN">
                      <input value={form.EAN || ''} readOnly={isReadOnly} onChange={(e) => upd('EAN', e.target.value)} placeholder="Código de barras" style={{ width: '100%', height: '32px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: isReadOnly ? C.surfaceAlt : C.surface, color: isReadOnly ? C.textMuted : C.text, fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
                    </Field>
                    <Field label="Data de Contagem">
                      <input type="date" value={form.Data_Contagem} onChange={(e) => upd('Data_Contagem', e.target.value)} style={{ width: '100%', height: '32px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surface, color: C.text, fontSize: '14px', boxSizing: 'border-box' }} />
                    </Field>
                    <Field label="Objetivo Cobertura">
                      <select value={form.Objetivo_Cobertura} onChange={(e) => upd('Objetivo_Cobertura', Number(e.target.value))} style={{ width: '100%', height: '32px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surface, color: C.text, fontSize: '14px', boxSizing: 'border-box' }}>
                        {[15, 30, 45, 60, 90].map(d => <option key={d} value={d}>{d} dias</option>)}
                      </select>
                    </Field>
                  </div>
                </div>

                {!isReadOnly && <div>
                  <p style={{ fontSize: '11px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` }}>Associação de Cliente</p>
                  <select value={form.Email_Cliente} onChange={(e) => upd('Email_Cliente', e.target.value)}
                    style={{ width: '100%', height: '36px', padding: '0 12px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surface, color: C.text, fontSize: '14px', boxSizing: 'border-box' }}>
                    <option value=''>— Sem cliente associado —</option>
                    {clientes.map(c => (
                      <option key={c.id} value={c.email}>{c.nome} · {c.email}</option>
                    ))}
                  </select>
                  {form.Email_Cliente ? (
                    <div style={{ marginTop: '8px', padding: '8px 12px', backgroundColor: C.successSoft, borderRadius: '6px', fontSize: '12px', color: C.success, display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <CheckCircle size={12} /> Produto visível para <strong>{clientes.find(c => c.email === form.Email_Cliente)?.nome || form.Email_Cliente}</strong>
                    </div>
                  ) : (
                    <div style={{ marginTop: '8px', padding: '8px 12px', backgroundColor: C.surfaceAlt, borderRadius: '6px', fontSize: '12px', color: C.textMuted }}>
                      Sem cliente associado — produto visível no catálogo público.
                    </div>
                  )}
                  {historico.length > 0 && (
                    <div style={{ marginTop: '12px' }}>
                      <p style={{ fontSize: '11px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 6px' }}>Histórico de Clientes</p>
                      <div style={{ border: `1px solid ${C.border}`, borderRadius: '6px', overflow: 'hidden' }}>
                        {historico.map((h, i) => (
                          <div key={h.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', padding: '6px 10px', fontSize: '11px', background: i % 2 === 0 ? C.surface : C.surfaceAlt, borderBottom: i < historico.length - 1 ? `1px solid ${C.border}` : 'none' }}>
                            <span style={{ fontWeight: '600', color: C.text }}>{h.ex_dono_nome || h.ex_dono_email}</span>
                            <span style={{ color: C.textMuted, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{h.ex_dono_email}</span>
                            <span title={h.origem === 'manual' ? `Desassociado a mao${h.libertado_por ? ' por ' + h.libertado_por : ''}` : 'Solto pelo automatismo ao fim de 15 dias sem stock nem transitos'}
                              style={{ fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.4px', padding: '2px 5px', borderRadius: '3px', whiteSpace: 'nowrap', background: h.origem === 'manual' ? C.warningSoft : C.surfaceAlt, color: h.origem === 'manual' ? C.warning : C.textMuted }}>
                              {h.origem === 'manual' ? 'manual' : 'auto'}
                            </span>
                            <span style={{ color: C.textMuted, whiteSpace: 'nowrap' }}>{new Date(h.libertado_em).toLocaleDateString('pt-PT')}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                <div>
                  <p style={{ fontSize: '11px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` }}>Stock & Vendas</p>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                    <InputRow label="Vendas Mensais" campo="Vendas_Mensais" value={form.Vendas_Mensais} onUpd={upd} step={10} />
                    <InputRow label="Stock Atual" campo="Stock_Atual" value={form.Stock_Atual} onUpd={upd} step={10} />
                    <InputRow label="Lead Time (dias)" campo="Lead_Time" value={form.Lead_Time} onUpd={upd} step={1} min={1} readOnly={isReadOnly} />
                  </div>
                </div>

                {SLOTS_TRANSITO.map(n => (
                  <div key={n}>
                    <p style={{ fontSize: '11px', fontWeight: '700', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` }}>Encomenda em Trânsito #{n}</p>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <InputRow label="Qtd. em Trânsito" campo={`Transito${n}_Qtd`} value={form[`Transito${n}_Qtd`]} onUpd={upd} step={10} />
                      <Field label="Data de Chegada">
                        <input type="date" value={form[`Transito${n}_Data`]} onChange={(e) => upd(`Transito${n}_Data`, e.target.value)} style={{ width: '100%', height: '32px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surface, color: C.text, fontSize: '14px', boxSizing: 'border-box' }} />
                      </Field>
                    </div>
                  </div>
                ))}

                {/* Fecha o T1 quando o armazem confirma o que o sync nao viu.
                    Ver confirmarChegadaT1: nao se poe o T1 a zero a mao porque
                    isso congela os transitos que estao atras dele. */}
                {!isReadOnly && fmtInt(form.Transito1_Qtd) > 0 && (
                  <div>
                    <button
                      onClick={confirmarChegadaT1}
                      disabled={confirmandoChegada}
                      style={{ width: '100%', height: '34px', border: `1px solid ${C.success}`, borderRadius: '6px', background: confirmandoChegada ? C.bg : '#dff6dd', color: C.success, cursor: confirmandoChegada ? 'not-allowed' : 'pointer', fontSize: '12px', fontWeight: '700' }}>
                      {confirmandoChegada ? 'A confirmar…' : `Confirmar chegada do trânsito 1 (${fmtInt(form.Transito1_Qtd)} un)`}
                    </button>
                    <p style={{ margin: '5px 0 0', fontSize: '10.5px', color: C.textMuted, lineHeight: 1.45 }}>
                      Usa quando o armazém confirmou a entrada e o sistema não a fechou — normalmente porque houve vendas do mesmo artigo no dia em que chegou.
                      O trânsito 1 fecha e os seguintes sobem um lugar, com as respectivas facturas.
                    </p>
                  </div>
                )}
              </div>
            </fieldset>
            </div>

            <div style={{ padding: '16px 24px', borderTop: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, backgroundColor: C.surfaceAlt }}>
              {!isReadOnly && (
                <button onClick={eliminarProduto}
                  style={{ height: '34px', padding: '0 16px', backgroundColor: 'transparent', color: C.danger, border: `1px solid ${C.danger}`, borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <Trash2 size={13} /> Eliminar Produto
                </button>
              )}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={() => setEditMode(false)} style={{ height: '34px', padding: '0 16px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surface, cursor: 'pointer', fontSize: '13px', color: C.textMuted }}>
                  Cancelar
                </button>
                {!isReadOnly && (
                <button onClick={async () => { await guardar(); setEditMode(false) }} disabled={saving}
                  style={{ height: '34px', padding: '0 20px', backgroundColor: C.primary, color: C.primaryText, border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '700', cursor: saving ? 'not-allowed' : 'pointer', opacity: saving ? 0.7 : 1, display: 'flex', alignItems: 'center', gap: '8px', letterSpacing: '0.02em' }}>
                  <Save size={13} />{saving ? 'A guardar...' : 'Guardar Alterações'}
                </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL — NOVO PRODUTO */}
      {showNovoProduto && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: C.surface, borderRadius: '12px', border: `1px solid ${C.border}`, width: '100%', maxWidth: '480px', maxHeight: 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.22)', overflow: 'auto' }}>
            <div style={{ padding: '18px 24px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h2 style={{ fontSize: '16px', fontWeight: '700', color: C.text, margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Package size={16} color={C.text} /> Novo Produto
              </h2>
              <button onClick={() => setShowNovoProduto(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textMuted, padding: '4px', display: 'flex' }}>
                <X size={18} />
              </button>
            </div>
            <form onSubmit={criarProduto} style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
                <div style={{ gridColumn: '1 / -1' }}>
                  <Field label="Nome do Produto *">
                    <input type="text" required autoFocus value={novoProduto.Nome} onChange={(e) => setNovoProduto(p => ({ ...p, Nome: e.target.value }))} placeholder="Ex: Dior Sauvage EDP 100ml"
                      style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, outline: 'none', boxSizing: 'border-box' }} />
                  </Field>
                </div>
                <Field label="EAN">
                  <input type="text" value={novoProduto.EAN} onChange={(e) => setNovoProduto(p => ({ ...p, EAN: e.target.value }))} placeholder="Código de barras"
                    style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, outline: 'none', boxSizing: 'border-box' }} />
                </Field>
                <Field label="Vendas Mensais">
                  <input type="number" min="0" value={novoProduto.Vendas_Mensais} onChange={(e) => setNovoProduto(p => ({ ...p, Vendas_Mensais: Number(e.target.value) }))}
                    style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, outline: 'none', boxSizing: 'border-box' }} />
                </Field>
                <Field label="Stock Atual">
                  <input type="number" min="0" value={novoProduto.Stock_Atual} onChange={(e) => setNovoProduto(p => ({ ...p, Stock_Atual: Number(e.target.value) }))}
                    style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, outline: 'none', boxSizing: 'border-box' }} />
                </Field>
                <Field label="Lead Time (dias)">
                  <input type="number" min="1" value={novoProduto.Lead_Time} onChange={(e) => setNovoProduto(p => ({ ...p, Lead_Time: Number(e.target.value) }))}
                    style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, outline: 'none', boxSizing: 'border-box' }} />
                </Field>
                <Field label="Objetivo Cobertura">
                  <select value={novoProduto.Objetivo_Cobertura} onChange={(e) => setNovoProduto(p => ({ ...p, Objetivo_Cobertura: Number(e.target.value) }))}
                    style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, backgroundColor: C.surface, boxSizing: 'border-box' }}>
                    {[15, 30, 45, 60, 90].map(d => <option key={d} value={d}>{d} dias</option>)}
                  </select>
                </Field>
                <div style={{ gridColumn: '1 / -1' }}>
                  <Field label="Cliente Associado">
                    <select value={novoProduto.Email_Cliente} onChange={(e) => setNovoProduto(p => ({ ...p, Email_Cliente: e.target.value }))}
                      style={{ width: '100%', height: '34px', padding: '0 10px', border: `1px solid ${C.border}`, borderRadius: '6px', fontSize: '14px', color: C.text, backgroundColor: C.surface, boxSizing: 'border-box' }}>
                      <option value=''>— Sem cliente associado —</option>
                      {clientes.map(c => (
                        <option key={c.id} value={c.email}>{c.nome} ({c.email})</option>
                      ))}
                    </select>
                  </Field>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', paddingTop: '12px', borderTop: `1px solid ${C.border}` }}>
                <button type="button" onClick={() => setShowNovoProduto(false)} style={{ flex: 1, height: '36px', border: `1px solid ${C.border}`, borderRadius: '6px', backgroundColor: C.surface, cursor: 'pointer', fontSize: '14px', color: C.textMuted }}>Cancelar</button>
                <button type="submit" disabled={criando} style={{ flex: 2, height: '36px', border: 'none', borderRadius: '6px', backgroundColor: C.primary, color: C.primaryText, cursor: criando ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '700', opacity: criando ? 0.7 : 1, letterSpacing: '0.02em' }}>
                  {criando ? 'A criar...' : 'Criar Produto'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* CSS animations */}
      <style>{`@keyframes slideDown { from { opacity:0; transform: translate(-50%, -20px) } to { opacity:1; transform: translate(-50%, 0) } } @keyframes slideDownNoTransform { from { opacity:0; transform: translateY(-20px) } to { opacity:1; transform: translateY(0) } }`}</style>

      {/* POPOVER — Adicionar ao carrinho (Repor stock) */}
      {popoverAdd && (
        <div onClick={() => setPopoverAdd(null)}
          style={{ position:'fixed', inset:0, backgroundColor:'rgba(0,0,0,0.65)', display:'flex', alignItems:'flex-start', justifyContent:'center', zIndex:1000, padding:'80px 20px 20px 20px', backdropFilter:'blur(2px)', overflowY:'auto' }}>
          <div onClick={e => e.stopPropagation()}
            style={{ backgroundColor:C.surface, borderRadius:'10px', width:'100%', maxWidth:'520px', boxShadow:'0 24px 60px rgba(0,0,0,0.5)', overflow:'hidden', border:`3px solid ${C.accent}`, animation:'slideDownNoTransform 0.2s ease-out' }}>
            {/* Header amarelo destacado */}
            <div style={{ background:C.accent, padding:'14px 20px', display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:`1px solid ${C.accentDark}` }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <ShoppingCart size={20} color={C.accentText} />
                <div>
                  <div style={{ fontSize:'15px', fontWeight:'800', color:C.accentText, letterSpacing:'0.02em' }}>Adicionar ao carrinho</div>
                  <div style={{ fontSize:'11px', color:C.accentText, opacity:0.85, marginTop:2 }}>{popoverAdd.produto?.Nome}</div>
                </div>
              </div>
              <button onClick={() => setPopoverAdd(null)} style={{ background:'rgba(0,0,0,0.1)', border:'none', cursor:'pointer', color:C.accentText, padding:6, borderRadius:'50%', width:28, height:28, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <X size={16} />
              </button>
            </div>
            <div style={{ padding:'20px' }}>

            {(() => {
              const qtdMin = perfilEfectivo?.qtd_minima_compra || popoverAdd.produto?.qtd_minima_compra || 10
              const precoBase = isParticular
                ? Number(popoverAdd.produto?.preco_particular || 0)
                : (Number(popoverAdd.produto?.preco || 0) + portesDiff)
              const precoComIva = precoBase * (1 + IVA)
              const qtyValid = Number(qtdAdd) >= qtdMin
              const totalSemIva = precoBase * Number(qtdAdd || 0)
              const totalComIva = precoComIva * Number(qtdAdd || 0)
              return (
                <>
                  <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:'12px' }}>
                    <button onClick={() => setQtdAdd(Math.max(qtdMin, Number(qtdAdd) - qtdMin))}
                      style={{ width:36, height:36, border:`1px solid ${C.border}`, background:C.surface, borderRadius:'6px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <Minus size={14} />
                    </button>
                    <input type="number" min={qtdMin} step={qtdMin} value={qtdAdd}
                      onChange={e => setQtdAdd(e.target.value)}
                      style={{ flex:1, height:36, padding:'0 10px', border:`1px solid ${C.border}`, borderRadius:'6px', fontSize:14, textAlign:'center', fontWeight:600 }} />
                    <button onClick={() => setQtdAdd(Number(qtdAdd) + qtdMin)}
                      style={{ width:36, height:36, border:`1px solid ${C.border}`, background:C.surface, borderRadius:'6px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <Plus size={14} />
                    </button>
                    <span style={{ fontSize:11, color:C.textMuted, marginLeft:6 }}>un</span>
                  </div>
                  <div style={{ fontSize:11, color:C.textMuted, marginBottom:'12px' }}>
                    Mínimo: {qtdMin} un · Sugerido: {popoverAdd.qtdSugerida > 0 ? popoverAdd.qtdSugerida : '—'}
                  </div>

                  <div style={{ padding:'10px 12px', background:C.surfaceAlt, borderRadius:'6px', marginBottom:'14px', fontSize:12 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4, color:C.textMuted }}>
                      <span>Preço unitário</span>
                      <span style={{ fontVariantNumeric:'tabular-nums', color:C.text }}>{fmt(precoBase)} € s/IVA</span>
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4, color:C.textMuted }}>
                      <span>Subtotal s/IVA</span>
                      <span style={{ fontVariantNumeric:'tabular-nums', color:C.text }}>{fmt(totalSemIva)} €</span>
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between', fontWeight:700, color:C.text }}>
                      <span>Total c/IVA</span>
                      <span style={{ fontVariantNumeric:'tabular-nums' }}>{fmt(totalComIva)} €</span>
                    </div>
                  </div>

                  {!qtyValid && (
                    <div style={{ fontSize:11, color:C.danger, marginBottom:8 }}>
                      A quantidade tem de ser pelo menos {qtdMin} un.
                    </div>
                  )}

                  <div style={{ display:'flex', gap:8 }}>
                    <button onClick={() => setPopoverAdd(null)}
                      style={{ flex:1, height:38, border:`1px solid ${C.border}`, background:C.surface, color:C.text, borderRadius:'6px', cursor:'pointer', fontSize:13, fontWeight:600 }}>
                      Cancelar
                    </button>
                    <button disabled={!qtyValid}
                      onClick={() => { adicionarAoCarrinho(popoverAdd.produto, Number(qtdAdd)); setPopoverAdd(null) }}
                      style={{ flex:2, height:38, background: qtyValid ? C.primary : C.borderStrong, color:'#fff', border:'none', borderRadius:'6px', cursor: qtyValid ? 'pointer' : 'not-allowed', fontSize:13, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
                      <ShoppingCart size={13}/> Adicionar ao carrinho
                    </button>
                  </div>
                </>
              )
            })()}
            </div>
          </div>
        </div>
      )}

      {/* FLOATING — Acesso rápido ao carrinho (só clientes, quando tem items) */}
      {isReadOnly && carrinhoQtd > 0 && !toastCarrinho && (
        <button onClick={() => { try { sessionStorage.setItem('autoOpenCart', '1') } catch (_) {}; setActivePage && setActivePage('catalogo') }}
          title="Abrir carrinho e finalizar encomenda"
          style={{ position:'fixed', bottom:'24px', right:'24px', height:'52px', padding:'0 18px', background:C.primary, color:'#fff', border:'none', borderRadius:'26px', cursor:'pointer', display:'flex', alignItems:'center', gap:8, boxShadow:'0 8px 24px rgba(0,0,0,0.25)', fontSize:13, fontWeight:700, zIndex:900 }}>
          <ShoppingCart size={16}/>
          Finalizar encomenda · {carrinhoQtd} un
          <ChevronRight size={14}/>
        </button>
      )}

      {/* TOAST — confirmação de adição ao carrinho */}
      {toastCarrinho && (
        <div style={{ position:'fixed', top:'80px', left:'50%', transform:'translateX(-50%)', backgroundColor:'#16a34a', color:'#fff', padding:'14px 20px', borderRadius:'10px', boxShadow:'0 12px 40px rgba(0,0,0,0.35)', zIndex:1100, minWidth:'320px', maxWidth:'480px', animation:'slideDown 0.25s ease-out' }}>
          <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
            <Check size={18} style={{ marginTop:1, flexShrink:0 }} />
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, fontWeight:700, marginBottom:2 }}>
                +{toastCarrinho.qtdAdicionada} un adicionadas
              </div>
              <div style={{ fontSize:11, opacity:0.9, marginBottom:8, lineHeight:1.4 }}>
                {toastCarrinho.nomeProduto?.length > 50 ? toastCarrinho.nomeProduto.slice(0,50) + '…' : toastCarrinho.nomeProduto}
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10 }}>
                <span style={{ fontSize:11, opacity:0.9 }}>
                  Carrinho: {toastCarrinho.nProdutos} produto(s) · {fmt(toastCarrinho.valor)} €
                </span>
                <button onClick={() => { try { sessionStorage.setItem('autoOpenCart', '1') } catch (_) {}; setToastCarrinho(null); setActivePage && setActivePage('catalogo') }}
                  style={{ padding:'4px 10px', background:'rgba(255,255,255,0.2)', border:'1px solid rgba(255,255,255,0.4)', color:'#fff', borderRadius:'4px', cursor:'pointer', fontSize:11, fontWeight:700, whiteSpace:'nowrap' }}>
                  Finalizar agora →
                </button>
              </div>
            </div>
            <button onClick={() => setToastCarrinho(null)} style={{ background:'none', border:'none', cursor:'pointer', color:'#fff', padding:2, opacity:0.7 }}>
              <X size={14}/>
            </button>
          </div>
        </div>
      )}

    </div>
  )
}
